import Component from './Component';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
let initNum = 1;
let CAREERS = [];

// SPLIT ARRAY INTO CHUNKS
function splitArray (data, size) {
    while( data.length ) {
        CAREERS.push(data.splice(0, size));
    }
    return CAREERS;
}

/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Careers extends Component {

    decorator () {
        return {
            selector : '.js-careers',
            name : 'Careers',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        // separate first 3 files
        CAREERS.push(this.$item.splice(0, 3));
        // chunk array to 6
        splitArray(this.$item, 6);

        // BIND ELEMENTS
        this.bindElements();
    }


    cacheElements () {
        this.$body = this.element.querySelector('.js-careers-body');
        this.$item = Array.from(this.element.querySelectorAll('.js-career'));
        this.$button = this.element.querySelector('.js-careers-btn');
    }

    bindElements () {
        let items;

        if (!this.$button) { return; }

        this.$button.addEventListener('click', e => {
            if (CAREERS.length - 1 >= initNum) {
                for (let i = 0; i < CAREERS[initNum].length; i++) {
                    items = CAREERS[initNum];

                    items[i].classList.add(`is-show`);

                    setTimeout(() => {
                        items[i].classList.add('is-visible');
                    }, 350);
                }
            }


            if (CAREERS.length - 1 <= initNum) {
                this.$button.classList.add('is-hidden');
            }


            initNum++;
        })
    }

}
